import React from 'react'
import { connect } from 'react-redux'
import { fetchBNAIfNeeded } from '~/features/actions'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'

class BNA extends React.Component {

  componentDidMount(){
    const { match, history, dispatch } = this.props
    dispatch(fetchBNAIfNeeded())
  }

  render() {
    const { BNA } = this.props
    var settings = {
      dots: true,
      slidesToShow: 3,
      centerMode: true,
      infinite: true,
      speed: 500,
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            autoplay: true,
            slidesToShow: 3,
            arrows: false
          }
        },
        {
          breakpoint: 1440,
          settings: {
            autoplay: true,
            slidesToShow: 3,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            autoplay: true,
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    }
    const bnas = BNA.items.map((item, index) => {
      return (
        <div className="bna-wrapper" key={index}>
          <h2 className="margin">Best New Arrivals - {item.title[0].value}</h2>
          <Slider {...settings}>
            {item.field_image.map((image, index) => (
              <div key={index}>
                <Link to={item.article[0].url}>
                  <img src={image.url} alt={image.alt} />
                </Link>
              </div>
            ))}
          </Slider>
          <Link to={item.article[0].url}><div className="margin" dangerouslySetInnerHTML={{__html: item.body[0].value}}></div></Link>
        </div>
      )
    })
    return (
      <div id="best-new-arrivals">{bnas}</div>
    )

  }

}

export default connect( state => { return { BNA: state.BNA }}) (BNA)
